/** @module csi/widget/_svg/CanvasRightMenu */
define([
	"dojo/_base/lang",
	"dojo/aspect",
	"dojo/store/Observable",
	"dojo/topic",
	"underscore",
	"csi/canvas/storeFactory",
	"csi/card/_base",
	"csi/card/AttributeCard",
	"csi/def/Heading",
	"csi/heading/_base",
	"csi/heading/Specs",
	"csi/html",
	"csi/image/_base",
	"csi/locale",
	"csi/middleware/attributeRule/RuleService",
	"csi/model/image",
	"csi/reflection",
	"csi/service/filterAttributeService",
	"csi/store/Nodes",
	"csi/types",
	"csi/view/Toolbar",
	"csi/state/rootStore",
	"csi/xml",
	"csi/xml/Query",
	"./GridRight",
	"./_Plugin",
	"./ImageUpload",
	"./PluginFactory",
	"./RightMenuAccordionContainer",
	"./RightMenuAccordionItem",
	"./util",
	"dojo/text!csi/templates/canvasRightMenu.html"
], function(lang, aspect, Observable, topic, _, storeFactory, csiCard, AttributeCard, Heading, csiHeading, Specs,
	html, imageBase, locale, {addRuleSpecToFilterMap, applyRulesToQueryFromRuleSpecFilterMap}, {getImageSrc}, reflection, {getFilterSpecsForType}, Nodes, types, Toolbar,
	{localStore}, xml, Query, GridRight, _Plugin, ImageUpload, PluginFactory, RightMenuAccordionContainer, RightMenuAccordionItem, svgUtil, template) {

	const COLOR_SPECIFICATION = "ColorSpecification";
	const FOOD = "Food";
	const MATERIAL = "Material";
	const PRODUCT_PRESENTATION_SET = "ProductPresentationSet";
	const PRODUCT_PRESENTATION_SET_ITEM = "ProductPresentationSetItem";
	const PRODUCT_PRESENTATION_LAYOUT = "ProductPresentationLayout";
	const STYLE = "Style";
	const THEME = "Theme";
	const THEME_MASTER = "ThemeMaster";
	const CARD_WIDTH = 232;
	const SCROLLBAR_WIDTH = html.getVerticalScrollbarWidth();

	return PluginFactory.declare([Toolbar, _Plugin], {
		templateString: template,

		/** @property {Object} _gridRight - dgrid for Item Images */
		// _gridRight: null,

		/** @property {Object} _gridRightUpload - dgrid for Image Uploads */
		// _gridRightUpload: null,

		/** @property {string} attributePlaceholderType - type of the currently selected attribute, if appropriate */
		// attributePlaceholderType: undefined,

		/** @property {string} canvasType - type of the current canvas instance */
		canvasType: null,

		/** @property {Object} footerNode - Footer Node - goes underneath Image Preview and Placeholder List Containers */
		footerNode: null,

		/** @property {Object} imageHeading - image heading object */
		// imageHeading: null,

		/** @property {Object} itemImagesAccordion - Accordion for Item Images */
		// itemImagesAccordion: null,

		/** @property {DOMNode} imagePreviewContainerNode - Image Preview Container Node*/
		imagePreviewContainerNode: null,

		/** @property {NodesStore} itemStore - NodeStore for Item Images */
		// itemStore: null,

		/** @property {DOMNode} imageTabHeaderNode - Image Tab Header Node*/
		imageTabHeaderNode: null,

		/** @property {DOMNode} menuNode - menu container for accordions */
		menuNode: null,

		/** @property {RightMenuAccordionContainer} placeholderAccordionContainer - Placeholder accordion container for items array */
		placeholderAccordionContainer: null,

		/** @property {RightMenuAccordionItem[]} placeholderAccordions - Placeholder accordion items array */
		placeholderAccordions: null,

		/** @property {Object} placeholderNode - Placeholder node if one is selected in side menu */
		placeholderNode: null,

		/** @property {DOMNode} placeholderTypesContainerNode - Placeholder Types Container Node */
		placeholderTypesContainerNode: null,

		/** @property {DOMNode} placeholderTypesNode - Placeholder Types Node */
		placeholderTypesNode: null,

		/** @property {string} pluginName - name of plugin */
		pluginName: "canvasrightmenu",

		/** @property {string} presentationSubtype - subtype of current Presentation (Food, Material, Style) instance */
		presentationSubtype: null,

		/** @property {RightMenuAccordionItem[]} referenceDataAccordions - Reference Data accordion items array */
		referenceDataAccordions: null,

		/** @property {RightMenuAccordionContainer} referenceDataAccordionContainer - Reference Data accordion container for items array */
		referenceDataAccordionContainer: null,

		/** @property {DOMNode} referenceDataTypesNode - Reference Data Types Node */
		referenceDataTypesNode: null,

		/** @property {DOMNode} referenceDataContainerNode - Reference Data Container Node */
		referenceDataContainerNode: null,

		/** @property {DOMNode} rightMenuTabContainerNode - Right Menu Tab Container Node */
		rightMenuTabContainerNode: null,

		/** @property {DOMNode} typesTabHeaderNode - Types Tab Header Node */
		typesTabHeaderNode: null,

		/** @property {Object} uploadsAccordion - Accordion for Image Uploads */
		// uploadsAccordion: null,

		/** @property {NodesStore} uploadsStore - NodeStore for Image Uploads */
		// uploadsStore: null,

		/** Return whether or not this canvas type is "ProductPresentationLayout" */
		isProductPresentationLayout: function() {
			return this.canvasType === PRODUCT_PRESENTATION_LAYOUT;
		},

		/** Return boolean indicating whether to load reference data */
		shouldLoadReferenceData: function() {
			return this.isProductPresentationLayout() && storeFactory.getReferenceDataTypes(this.canvasType).length;
		},

		/** Cancel store requests from image stores in the right side menu */
		cancelStoreRequests: function() {
			const {_gridRight, _gridRightUpload} = this;
			_gridRight.store.cancelRequest();
			_gridRightUpload.store.cancelRequest();

			// if cancel happens before the store is finished loading, "noDataMessage" is set to request canceled, set this back
			_gridRight.set("noDataMessage", locale.resource("SEARCH_NO_RESULTS"));
			_gridRightUpload.set("noDataMessage", locale.resource("SEARCH_NO_RESULTS"));
		},

		/**
		 * Handle click for a tab in right side menu
		 */
		clickTab: function(selectedTab, selectedContainer) {
			const containers = selectedContainer.parentElement.querySelectorAll(".csi-canvas-tab-container");
			const tabHeaders = selectedTab.parentElement.querySelectorAll(".csi-canvas-tab-header");
			containers.forEach((container) => container.classList.toggle(html.CSS_HIDE, container !== selectedContainer));
			tabHeaders.forEach((tab) => tab.classList.toggle("csi-canvas-tab-selected", tab === selectedTab));
			this.clearImageSelections();
		},

		/**
		 * Show images tab in right side menu
		 */
		showImagesTab: function() {
			const {
				footerNode,
				imagePreviewContainerNode,
				imageTabHeaderNode,
			} = this;

			this.clickTab(
				imageTabHeaderNode,
				imagePreviewContainerNode,
			);
			footerNode.innerText = locale.resource("CanvasImagePreviewFooter");
		},

		/**
		 * Show types tab in right side menu
		 */
		showTypesTab: function() {
			const {
				footerNode,
				placeholderTypesContainerNode,
				typesTabHeaderNode,
			} = this;

			this.clickTab(
				typesTabHeaderNode,
				placeholderTypesContainerNode,
			);
			footerNode.innerText = locale.resource("CanvasPlaceholderTypesFooter");
		},

		/**
		 * Show types tab in right side menu
		 */
		showReferenceDataTab: function() {
			const {
				footerNode,
				referenceDataTabHeaderNode,
				referenceDataContainerNode,
			} = this;

			this.clickTab(
				referenceDataTabHeaderNode,
				referenceDataContainerNode,
			);
			footerNode.innerText = locale.resource("CanvasPlaceholderTypesFooter");
		},

		/** Handler for placeholder back arrow */
		onClickPlaceholderArrow: function() {
			this.refreshPlaceholderTypes();
		},

		/** Handler for placeholder back arrow */
		onClickPlaceholderArrowReferenceData: function() {
			this.refreshReferenceDataTypes();
		},

		/**
		 * Add aspects to control Dnd behavior
		 * the image is dropped outside the dnd source into canvas area so its going to trigger a cancel event
		 * detect the area on screen where its dropped to decide if its a cancel event or a canvas drop event
		 */
		postCreate: function() {
			const {view} = this.editor;
			this.canvasType = view.getViewNodeType();
			this.presentationSubtype = this.getPresentationProductType(view);

			const {
				canvasType,
				referenceDataTabHeaderNode,
				typesTabHeaderNode,
			} = this;

			// set dijitToolbarNode to view toolbarNode,as _onContainerKeypress is set on postCreate
			this.dijitToolbarNode = view.toolbarNode.dijitToolbarNode;
			this.own(
				topic.subscribe("/csi/image/browser/update", () => this.refreshMyUploadsPane()),
				topic.subscribe("/csi/canvas/displayTypeInstances", () => this.showTypesTab()),
			);

			if (view.isCanvasTemplate()) {
				typesTabHeaderNode.classList.add("csi-canvas-tab-disabled");
			} else {
				typesTabHeaderNode.onclick = () => {
					this.showTypesTab();
				}
			}

			aspect.after(view, "clearImageSelections", () => {
				this.clearImageSelections();
			});

			aspect.after(view, "updateGridRightUpload", (fileNodes) => {
				this.afterGridRightUpload(fileNodes);
			}, true); // receiveArguments flag set to true

			// hide reference data tab content (tab + tab divider) for non layout type canvas instances
			if (canvasType !== PRODUCT_PRESENTATION_LAYOUT) {
				referenceDataTabHeaderNode.previousElementSibling.classList.add(html.CSS_HIDE);
				referenceDataTabHeaderNode.classList.remove("csi-flex-row");
				referenceDataTabHeaderNode.classList.add(html.CSS_HIDE);
			}

			this.inherited(arguments);
		},

		/**
		 * Renderer for cells
		 * @param {node} node
		 */
		_renderCell: function(node) {
			const src = getImageSrc(node, null, reflection.ATTR_THUMBNAIL);
			const viewable = getImageSrc(node, null, reflection.ATTR_VIEWABLE);
			const image = new Image();
			const {style} = image;

			// placeholder for image will be a 98 pixel square box
			style.width = style.height = "98px";
			image.onload = () => {
				// reset dimensions after image loads so true dimensions take its place
				style.width = style.height = ""
			}
			image.src = src;
			image.setAttribute("srcDrop", viewable);

			const childDiv = document.createElement("div");
			childDiv.classList.add("attrImage", "dojoDndHandle");
			childDiv.title = node.$Name;
			childDiv.appendChild(image);

			const div = document.createElement("div");
			div.classList.add("dojoDndItem");
			div.appendChild(childDiv);

			return div;
		},

		/**
		 * Prepend image upload button to already rendered dgrid content
		 */
		addImageUploadButton: function() {
			const {
				_gridRightUpload,
				editor,
			} = this;

			const itemNode = _gridRightUpload.domNode.querySelector(".dgrid-content");
			const imageUploadNode = itemNode.querySelector("#csi-canvas-image-upload-button");
			if (!imageUploadNode) {
				const imageUpload = new ImageUpload({editor});
				imageUpload.startup();
				imageUpload.domNode.classList.add("ui-state-default");
				imageUpload.domNode.id = "csi-canvas-image-upload-button";
				itemNode.prepend(imageUpload.domNode);
			}
		},

		/**
		 * Clear selection of images for use on blur
		 */
		clearImageSelections: function() {
			const gridRight = this._gridRight;
			const gridRightUpload = this._gridRightUpload;
			// clear grid selections on blur
			if (gridRight) {
				gridRight.clearSelection();
				gridRightUpload.clearSelection();
				gridRight.clearDnDHandle();
				gridRightUpload.clearDnDHandle();
			}
		},

		/**
		 * Render a new, custom GridRight
		 * @param {string} placeholderType - type of placeholder rendering grid right for
		 * @param {Function} getMoreRows - add an optional getMoreRows function to change the way new rows are fetched
		 * @param {boolean} referenceData - indicate whether referenceData is being rendered
		 */
		renderGridRight: function(placeholderType, getMoreRows, referenceData) {
			const loadingMessage = locale.resource("LoadingEllipsis");
			const moreLabel = locale.resource("ViewQueryMore");
			const noDataMessage = locale.resource("SEARCH_NO_RESULTS");
			if (placeholderType === reflection.ATTR_IMAGES) {
				// define column cells for list view
				const columns = {
					Images: {
						label: locale.resource(types.FORMAT_IMAGE),
						renderCell: lang.hitch(this, this._renderCell),
						sortable: false
					}
				};

				const gridRight = new GridRight({
					columns: columns,
					dndType: "image",
					loadingMessage,
					moreLabel,
					noDataMessage,
					renderRow: lang.hitch(this, this._renderCell),
					showHeader: false,
				});
				if (getMoreRows) {
					gridRight.getMoreRows = getMoreRows;
				}
				return gridRight;
			} else {
				return new GridRight({
					dndType: "placeholder",
					loadingMessage,
					moreLabel,
					noDataMessage,
					placeholderType,
					renderRow: this.renderPlaceholderTypeRow.bind(this, referenceData),
					selectionMode: "single",
				});
			}
		},

		/**
		 * Loads the images on right pane only in edit mode
		 */
		loadOrRefreshMenu: function() {
			const {
				editor,
				menuNode,
			} = this;

			const {view} = editor;

			const node = view.canvasOwner;
			this.itemStore = imageBase.getNodeImageStore(node);
			this.uploadsStore = Observable(imageBase.getUploadsStore(localStore.imageSort));

			if (!this._gridRight && !this._gridRightUpload) {

				this.imageHeading = lang.mixin(new Heading(), {
					m_id: reflection.ATTR_THUMBNAIL,
					m_format: types.FORMAT_IMAGE,
					m_name: reflection.ATTR_THUMBNAIL,
					m_right: "Write"
				});

				this._gridRight = this.renderGridRight(reflection.ATTR_IMAGES);

				const getMoreRows = (start) => {
					// adding the upload button to grid offsets default limit 20 by one and makes is asymmetric
					// so pass 19 on first request and 20 from next one on wards
					return start === 0 ? 19 : 20;
				}

				this._gridRightUpload = this.renderGridRight(reflection.ATTR_IMAGES, getMoreRows);

				const accordions = [];
				this.itemImagesAccordion = new RightMenuAccordionItem({
					accordionExpanded: true,
					contentNode: this._gridRight.domNode,
					title: locale.resource("ItemImages"),
				});
				accordions.push(this.itemImagesAccordion);
				this._gridRight.onTotal = (total) => this.itemImagesAccordion.setTotal(total);

				this.uploadsAccordion = new RightMenuAccordionItem({
					accordionExpanded: true,
					contentNode: this._gridRightUpload.domNode,
					title: locale.resource("ImageBrowserUploads"),
				});
				accordions.push(this.uploadsAccordion);
				this._gridRightUpload.onTotal = (total) => this.uploadsAccordion.setTotal(total);

				const accordionContainer = new RightMenuAccordionContainer({
					initalAccordion: 0,
					accordions,
					bExpandAllAccordions: true,
				})
				accordionContainer.startup();
				accordionContainer.placeAt(menuNode);
			}
			this._gridRight.set("store", this.itemStore, {}, {});

			// my uploads store
			this.uploadsStore.sortQuery = new Query().SortByAttr(reflection.ATTR_MODIFIED_AT, null, null, true);
			this._gridRightUpload.set("store", this.uploadsStore, {}, {});

			this.addImageUploadButton();

			if (this.shouldLoadReferenceData()) {
				this.refreshReferenceDataTypes();
			}

			this.refreshPlaceholderTypes();
		},

		/**
		 * Refresh item images pane after images upload
		 */
		refreshItemImagePane: function() {
			if (this._gridRight) {
				this.itemStore.reset();
				this._gridRight.refresh();
			}
		},

		/**
		 * Refresh my uploads pane after image upload
		 */
		refreshMyUploadsPane: function() {
			if (this._gridRightUpload) {
				// reset the store to fix the sortorder of newly updated items
				this.uploadsStore.reset();
				this._gridRightUpload.refresh();

				// readd image upload button
				this.addImageUploadButton();
			}
		},

		/**
		 * Fill placeholder with target being the selected placeholder in canvas
		 * @param {C8Node} object - C8 node that to fill placeholder target with
		 */
		fillPlaceholderWithTarget: function(object) {
			const {editor} = this;
			const placeholderTarget = editor.canvasApp.selection.getSelectedAttributePlaceholder();
			if (placeholderTarget && svgUtil.getStartTypeForKey(placeholderTarget.keys[0]) === object.$Type) {
				editor.fillPlaceholderWithAttributes(object, placeholderTarget);
			}
		},

		/**
		 * Get the product type of a Product Presentation
		 * @param {View} view - Canvas View
		 * @return {string | null}
		 */
		getPresentationProductType: function(view) {
			const viewParentUrl = view.getViewNode().__Parent__;
			const viewParentNode = view.cacheView.getNode(viewParentUrl);
			return viewParentNode ? xml.enumGetText(viewParentNode.ProductType) : null;
		},

		/**
		 * Refresh the reference data types.
		 * @param {C8Node} selectedNode - C8 node that was selected
		 */
		refreshReferenceDataTypes: function(selectedNode) {
			const {
				editor,
				canvasType,
				referenceDataTypesNode,
			} = this;

			// remove any previous child nodes to update with new ones
			while (referenceDataTypesNode.hasChildNodes()) {
				referenceDataTypesNode.removeChild(referenceDataTypesNode.lastChild);
			}

			const {view} = editor;
			const {cacheView} = view;

			let selectedNodeAccordionContainer;
			if (selectedNode) {
				const {$Type} = selectedNode;
				this.placeholderNode = selectedNode;
				const referenceDataTypes = storeFactory.getTargetTypes($Type);
				this.referenceDataAccordions = [];
				referenceDataTypes.forEach((placeholderType, index) => {
					const useStore = storeFactory.get($Type, placeholderType, selectedNode.$URL, cacheView);
					if (useStore) {
						this.referenceDataAccordions.push(this.populateAccordion(placeholderType, useStore, true));
					}
				});
				selectedNodeAccordionContainer = new RightMenuAccordionContainer({
					accordions: this.referenceDataAccordions,
					headerNode: selectedNode,
					initalAccordion: 0,
					onClickPlaceholderArrow: this.onClickPlaceholderArrowReferenceData.bind(this),
					renderHeaderCallback: this.renderGridRight.bind(this),
				})
				html.setVisible(this.referenceDataAccordionContainer.domNode, false);
			} else if (!this.referenceDataAccordionContainer) {
				const referenceDataTypes = storeFactory.getReferenceDataTypes(canvasType);
				this.referenceDataAccordions = [];
				referenceDataTypes.forEach((placeholderType, index) => {
					const useStore = storeFactory.getReferenceDataTypeStore(canvasType, placeholderType, view.urlRoot, cacheView);
					if (useStore) {
						this.referenceDataAccordions.push(this.populateAccordion(placeholderType, useStore, true));
					}
				});
				this.referenceDataAccordionContainer = new RightMenuAccordionContainer({
					accordions: this.referenceDataAccordions,
					initalAccordion: 0,
				})
			} else {
				html.setVisible(this.referenceDataAccordionContainer.domNode, true);
			}
			(selectedNodeAccordionContainer || this.referenceDataAccordionContainer).placeAt(referenceDataTypesNode);
		},

		/**
		 * Refresh the placeholder types, for example on initialization or when page changes.
		 * @param {C8Node} selectedNode - C8 node that was selected
		 */
		refreshPlaceholderTypes: function(selectedNode) {
			if (this.editor.view.isCanvasTemplate()) {
				return;
			}

			const {
				editor,
				canvasType,
				placeholderTypesNode,
				presentationSubtype,
			} = this;

			// remove any previous child nodes to update with new ones
			while (placeholderTypesNode.hasChildNodes()) {
				placeholderTypesNode.removeChild(placeholderTypesNode.lastChild);
			}

			const {view} = editor;
			const {colorQuery} = view;
			const placeholderTypes = storeFactory.getPlaceholderTypes(canvasType, presentationSubtype, selectedNode);

			this.placeholderAccordions = [];
			placeholderTypes.forEach((placeholderType, index) => {
				const useStore = storeFactory.queryMaker(canvasType, selectedNode, placeholderType, presentationSubtype, view, colorQuery);
				useStore.reset();
				this.placeholderAccordions.push(this.populateAccordion(placeholderType, useStore));
			});

			let placeholderAccordionContainer;
			if (selectedNode) {
				this.placeholderNode = selectedNode;
				html.setVisible(this.placeholderAccordionContainer.domNode, false);
				placeholderAccordionContainer = new RightMenuAccordionContainer({
					accordions: this.placeholderAccordions,
					headerNode: selectedNode,
					initalAccordion: 0,
					onClickPlaceholderArrow: this.onClickPlaceholderArrow.bind(this),
					refreshPlaceholderTypes: this.refreshPlaceholderTypes.bind(this),
					renderHeaderCallback: this.renderGridRight.bind(this),
				})
			} else {
				this.placeholderAccordionContainer = new RightMenuAccordionContainer({
					accordions: this.placeholderAccordions,
					initalAccordion: 0,
					refreshPlaceholderTypes: view.isProductPresentationLayout() ? this.refreshPlaceholderTypes.bind(this) : null,
					subscribe: true,
				})
			}
			(placeholderAccordionContainer || this.placeholderAccordionContainer).placeAt(placeholderTypesNode);
		},

		/**
		 * Populate placeholder store with either a search query or pre-populated store
		 * @param {string} placeholderType - type of placeholder store to populate
		 * @param {Nodes} placeholderStore - node store to use
		 * @param {boolean} isReferenceData - flag to indicate reference data
		 * @return {RightMenuAccordionItem}
		 */
		populateAccordion: function(placeholderType, placeholderStore, isReferenceData) {
			const _gridRightPlaceholder = this.renderGridRight(placeholderType, undefined, isReferenceData);
			_gridRightPlaceholder.startup();

			_gridRightPlaceholder.isReferenceData = isReferenceData;
			_gridRightPlaceholder.placeholderType = placeholderType;

			if (placeholderType === reflection.ATTR_IMAGES) {
				const rightMenuAccordionItem = new RightMenuAccordionItem({
					contentNode: _gridRightPlaceholder.domNode,
					placeholderType,
					title: locale.typePlural("Image"),
				});
				_gridRightPlaceholder.onTotal = (total) => rightMenuAccordionItem.setTotal(total);
				_gridRightPlaceholder.set("store", placeholderStore, {}, {});
				return rightMenuAccordionItem;
			} else {

				const slimCardSpecs = csiCard.getAttributeCardSlimSpecs(placeholderType);
				const queryOptions = {start: 0, count: 20, useCache: false};
				const specs = new Specs();
				for (const spec of slimCardSpecs.attributeSpecs) {
					specs.add(spec);
				}
				placeholderStore.querySpecStore = specs.getQueryStore();

				const queryMap = {};

				/**
				 * Callback to update store nodes with filtering based on search string and slim specs
				 * @param {string} searchString - string to search specs by
				 */
				const updateGridRightStore = async function(searchString) {
					const {isReferenceData, placeholderType, store} = _gridRightPlaceholder;

					for (const spec of slimCardSpecs.attributeSpecs) {
						queryMap[spec.queryKey] = xml.getClientMatchValue(searchString) || "*";
					}

					store.queryByAny = true;

					const queryOptions = {
						start: 0,
						count: 20,
						useCache: false,
					}

					store.reset();
					_gridRightPlaceholder.set("store", store, queryMap, queryOptions);
				};

				// get filter attributes
				const filterSpecs = getFilterSpecsForType(placeholderType);

				const rightMenuAccordionItem = new RightMenuAccordionItem({
					applyFilterCallback: (accordionFilter) => {
						const {accordionItem, multiSelect} = accordionFilter;
						// if this is our first time calling this function for this accordion, need to initialize the map
						accordionFilter.filterMap ||= {};
						const {originalQuery, placeholderStore, searchCallback, textBox} = accordionItem;
						const {spec} = multiSelect;
						const {filterMap} = accordionFilter;
						const values = multiSelect.value;
						addRuleSpecToFilterMap(spec, values, filterMap);

						placeholderStore.filterQuery = applyRulesToQueryFromRuleSpecFilterMap(
							originalQuery,
							filterMap,
						);
						placeholderStore.reset();
						const {value} = textBox;
						searchCallback(value);
					},
					contentNode: _gridRightPlaceholder.domNode,
					filterSpecs,
					originalQuery: placeholderStore.filterQuery,
					placeholderStore,
					placeholderType,
					searchCallback: updateGridRightStore,
					title: placeholderStore.pathTitle,
				});
				placeholderStore.reset();
				_gridRightPlaceholder.onTotal = (total) => rightMenuAccordionItem.setTotal(total);
				_gridRightPlaceholder.set("store", placeholderStore, queryMap, queryOptions);
				return rightMenuAccordionItem;
			}
		},

		/**
		 * Updates uploadsStore with new image nodes
		 * @param {Node[]} fileNodes - new file nodes
		 */
		afterGridRightUpload: function(fileNodes) {
			fileNodes.forEach((node) => this.uploadsStore.add(node));
			this.refreshMyUploadsPane();
		},

		/**
		 * Render placeholder type row
		 * @param {boolean} referenceData - flag indicating this is a reference data row
		 * @param {C8Node} object - C8 node to render
		 * @param {Object} options - optional options
		 * @return {Object} row
		 */
		renderPlaceholderTypeRow: function(referenceData, object, options) {
			const {editor} = this;
			const {view} = editor;
			const ctx = view.getContext(object.$URL);
			const objType = object.$Type;
			const isHeaderNode = this.placeholderNode && this.placeholderNode === object;
			const canDrillDown =
				!isHeaderNode &&
				this.isProductPresentationLayout() &&
				(
					objType === PRODUCT_PRESENTATION_SET ||
					objType === PRODUCT_PRESENTATION_SET_ITEM ||
					objType === COLOR_SPECIFICATION ||
					objType === FOOD ||
					objType === MATERIAL ||
					objType === STYLE ||
					objType === THEME ||
					objType === THEME_MASTER
				);

			const params = {
				ctx,
				primarySlimLinkStyle: canDrillDown || referenceData,
				slim: true,
				slimLabels: true,
				stacked: true,
				width: CARD_WIDTH - SCROLLBAR_WIDTH,
			};

			_.extend(params, csiCard.getAttributeCardSpecs(object.$Type));

			if (xml.nodeGetType(object) === PRODUCT_PRESENTATION_SET_ITEM) {
				params.imageSpec = svgUtil.getImageSpecForSetItem(object, view);
			}

			// Set slim stacked tooltips.
			params.primaryTooltip = params.attributeSpecs[0] ? csiHeading.toText(ctx, params.attributeSpecs[0].heading) : null;
			params.secondaryTooltip = params.attributeSpecs[1] ? csiHeading.toText(ctx, params.attributeSpecs[1].heading) : null;

			const row = document.createElement("div");

			html.setElementContext(row, object.$URL);

			row.classList.add("dojoDndItem", "dojoDndHandle", "ui-state-default-slim-card");

			view.when(csiCard.getAttributeCardDependencies(ctx), function() {
				new AttributeCard(params).placeAt(row);
			});

			// if it's the header node, we don't want to be able to single click it
			if ((isHeaderNode || !canDrillDown) && !referenceData) {
				row.addEventListener("dblclick", () => this.fillPlaceholderWithTarget(object));
			} else {
				row.addEventListener("click", (e) => {
					if (!this.timer || Date.now() - this.timer > 200) {
						this.timer = Date.now();
					} else {
						this.timer = undefined;
						if (this.singleClickTimer) {
							clearTimeout(this.singleClickTimer);
						}
						this.fillPlaceholderWithTarget(object);
						return;
					}

					this.singleClickTimer = setTimeout(() => {
						if (this.isProductPresentationLayout()) {
							let selectNode = object;
							if (xml.nodeGetType(selectNode) === PRODUCT_PRESENTATION_SET_ITEM) {
								selectNode = view.cacheView.getNode(object.PPIProduct);
							}

							if (referenceData) {
								this.refreshReferenceDataTypes(selectNode);
							} else {
								this.refreshPlaceholderTypes(selectNode);
							}
						}
					}, 200);
				});
			}
			return row;
		},
	});
});